/**
 * Created by alvinoktavianus on 04/10/17
 */

class ReadOnlyItemVariant extends React.Component {
  render () {
    return <input {...this.props.input} className={`form-control`} disabled />
  }
}

export default ReadOnlyItemVariant



// WEBPACK FOOTER //
// ./app/components/Fields/ReduxForm/ReadOnlyItemVariant/ReadOnlyItemVariant.js